import { FormEventHandler, ReactNode, useState } from "react";
import { Drawer } from "./Drawer";
import { clsx } from "clsx";

type FormDrawerProps = {
  title?: string;
  onClose: () => void;
  onSubmit: FormEventHandler;
  children: ReactNode;
  primaryLabel: string;
  secondaryLabel: string;
  onPrimaryButtonClick?: () => void; // If this is not defined, we assume the primary button is the submit button
  onSecondaryButtonClick?: () => void;
  disablePrimaryButton?: boolean;
};

export function FormDrawer({
  title,
  onClose,
  onSubmit,
  children,
  primaryLabel,
  secondaryLabel,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  disablePrimaryButton,
}: FormDrawerProps) {
  const [isInvalid, setIsInvalid] = useState(false);

  return (
    <Drawer className="form-drawer" onClose={onClose}>
      <form
        method="dialog"
        className={clsx("form-drawer__form", isInvalid && "form-invalid")}
        onInvalid={() => setIsInvalid(true)}
        onSubmit={onSubmit}
      >
        <div className="form-drawer__head">
          {title && <h3 className="form-drawer__title">{title}</h3>}
          <button
            className="button--icon form-drawer__button-close"
            onClick={onClose}
            type="button"
          />
        </div>
        <div className="form-drawer__form-content">{children}</div>
        <div className="form-drawer__form-controls">
          <button
            className="form-drawer__button button"
            type={onPrimaryButtonClick ? "button" : "submit"}
            onClick={onPrimaryButtonClick}
            disabled={disablePrimaryButton}
          >
            {primaryLabel}
          </button>
          <button
            className="form-drawer__button button button--tertiary"
            type="button"
            onClick={onSecondaryButtonClick || onClose}
          >
            {secondaryLabel}
          </button>
        </div>
      </form>
    </Drawer>
  );
}
